// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ab014ef4","665":"0663d615"}[chunkId] + ".chunk.js";
};